// extracted by mini-css-extract-plugin
module.exports = {"tr":"TableRow_tr__2Koo7"};